<div
  class="circle-outline"
  [matTooltip]="visit.toolTip ?? ''"
  [matTooltipDisabled]="!visit.toolTip"
  [style]="{ 'border-radius': iconMini || flag ? '0%' : '50%' }"
  [class.circle-overflow]="visit.matIcon && visit.iconID === undefined"
  matTooltipPosition="above"
  matTooltipClass="white-space-pre-line"
>
  <div
    [class.icon-flag]="flag"
    [class.icon-material]="
      (visit.matIcon && visit.iconID === undefined) || visit.grupo === 'PARADA'
    "
    [class.icon-mini]="iconMini"
    [ngStyle]="{ 'background-image': imageIcon }"
    class="icon"
  >
    <ng-container *ngIf="visit.matIcon">
      <mat-icon
        [style.color]="visit.matIcon === 'local_shipping' ? color : matColor"
        [class.truck]="visit.matIcon === 'local_shipping'"
        [class.alert]="visit.matIcon === 'report_problem'"
        >{{ visit.matIcon }}</mat-icon
      >
    </ng-container>
  </div>
  <div [ngStyle]="{ 'font-size': fontSize }" class="text">{{ iconText }}</div>
</div>
